import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { FatalErrorPage } from 'pages/fatal-error/fatal-error';

@NgModule({
    declarations: [FatalErrorPage],
    imports: [PagesModule, ComponentsModule]
})
export class FatalErrorPageModule {}
